<template>
  <div>
    <AddRecommendation
        :showAddRecommendation="showAddRecommendation"
        @close="showAddRecommendation = false"
        :employeeNumber="employeeNumber"
        :reviewPeriod="reviewPeriod"
        :reload="reload"
    />
    <div class="bg-white rounded-md">
      <div
          class="border-b-0.5 flex flex-wrap lg:gap-0 gap-4 justify-end items-center py-3"
      >
        <div>
          <button
              @click="showAddRecommendation = true"
              class="bg-primary text-white rounded-full px-3 py-1 text-sm"
          >
            Add Recommendation
          </button>
        </div>
      </div>
      <div class="">
        <ve-table :columns="columns" :table-data="recommendations"  />
        <transition name="fade">
          <div
              v-if="loading"
              class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
          >
            <loader class="center-h-v" />
          </div>
        </transition>
        <div
            v-if="!loading && !recommendations"
            class="flex flex-col justify-center items-center h-full mt-5"
        >
          <el-empty :image-size="70" description="No Data"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddRecommendation from "@/components/PerformanceReview/recommendation/addRecommendation.vue";
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import {mapGetters} from "vuex";
export default {
  name: "RecommendationHome",
  components: { AddRecommendation, Loader },
  props:["employeeNumber", "reviewPeriod"],
  computed:{
    ...mapGetters(["getOrganization", "getToken"]),
  },
  data() {
    return {
      showAddRecommendation: false,
      loading:false,
      columns: [
        {
          field: "Recommendation Type",
          key: "a",
          title: "Recommendation Type",
          renderBodyCell: ({row}) => (
              <p className="capitalize">{row.RecommendationType}</p>
          ),
        },

        { field: "RecommendationDate", key: "c", title: "Recommendation Date",
          renderBodyCell: ({row}) => (
              <p className="capitalize">{row.PerformancePeriod}</p>
          ),
        },

        {
          field: "Comments",
          key: "f",
          title: "Comments",
          renderBodyCell: ({row}) => (
              <p className="capitalize">{row.Description}</p>
          ),
        },
      ],
      recommendations:[],
      tableData: [
        {
          Recommendation: "Training needed",
          RecommendationDate: "15 Dec 2022",
          CycleName: "Half Year",
          Grade: 3.1,
          Comments: "56%",
        },
      ],
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
    };
  },
  created() {
    this.getRecommendations()
  },
  methods: {
    reload() {
      this.showAddRecommendation = false
      this.getRecommendations()
    },
   async getRecommendations(){
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`${this.getOrganization}/performance/recommendation/${this.$ApiVersion}/request`
          ,{
        params:{
          employeeId:this.employeeNumber,
          performancePeriodId:this.reviewPeriod,
        }, ...options
          }).then((response)=>{
        if (response.data.StatusCode==200){
          this.recommendations=response.data.Data
          this.loading=false
        } else {
          this.get_error = response.data.StatusMessage;
        }
      },
          (error)=>{
            this.get_error = error.message;
          }
      ).catch((error) => {
        this.$notify.error({
          title: 'Failure',
          message: 'Error occured while fetching records.',
        });
        console.error('Error fetching data:', error);
      });
    }
  },
};
</script>
